'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const MATERIAL_SYMBOLS_HREF =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap';

const ICON_ROUTES = [
  '/commande-a-emporter',
  '/takeaway',
  '/para-llevar',
  '/mentions-legales',
  '/legal-notice',
  '/aviso-legal',
  '/politique-de-confidentialite',
  '/privacy-policy',
  '/politica-de-privacidad',
  '/cgu',
  '/terms-of-use',
  '/condiciones-de-uso',
  '/cgv',
  '/terms-of-sale',
  '/condiciones-de-venta',
];

function routeUsesMaterialSymbols(pathname: string) {
  const usesCategoryMenuIcons = pathname.includes('/menu/');
  return (
    usesCategoryMenuIcons ||
    ICON_ROUTES.some((route) => pathname === route || pathname.endsWith(route) || pathname.includes(`${route}/`))
  );
}

export function MaterialSymbolsLoader() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname || !routeUsesMaterialSymbols(pathname)) return;
    if (document.querySelector(`link[href="${MATERIAL_SYMBOLS_HREF}"]`)) return;

    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = MATERIAL_SYMBOLS_HREF;
    document.head.appendChild(stylesheet);
  }, [pathname]);

  return null;
}
